export enum DebounceCode {
  AcceptAll = '4',
  Deliverable = '5',
  Disposable = '3',
  Invalid = '6',
  Role = '8',
  SpamTrap = '2',
  Syntax = '1',
  Unknown = '7',
}
